import useChangesQuery from '~/hooks/services/servicenow/queries/useChangesQuery'

import moment from 'moment'
import { IoGitPullRequest } from 'react-icons/io5'
import { useNavigate } from 'react-router'

import { Tile, TileFooter, TileHeader, TileListContent, TileListItem } from '../Tile'

const today = moment().startOf('day')
const twoWeeksLater = moment().add(14, 'days').endOf('day')
const dateRange = [today, twoWeeksLater] as const

const UpcomingChangesTile = () => {
  const navigate = useNavigate()

  const { data: upcomingChanges, isLoading: isUpcomingChangesLoading } = useChangesQuery({
    startDate: dateRange[0],
    endDate: dateRange[1],
    keyword: null,
    classification: null,
    category: null,
    state: ['Planned'],
    orderBy: 'starts',
    orderByDesc: false,
    take: 3,
    skip: 0,
    period: 'custom'
  })

  const formatDateRange = (starts: string, ends: string) => {
    const startDate = moment(starts)
    const endDate = moment(ends)

    if (startDate.isSame(endDate, 'day')) {
      return `${startDate.format('DD/MM/YY HH:mm')} - ${endDate.format('HH:mm')}`
    }
    return `${startDate.format('DD/MM/YY HH:mm')} - ${endDate.format('DD/MM/YY HH:mm')}`
  }

  /**
   * Navigates to the Changes page with a filter for planned changes and a date range for the next 14 days.
   * The ScrollToTop component will automatically reset the scroll position using SmoothScrollbar
   * since this navigation originates from a dashboard tile.
   */
  const handleNavigate = () => {
    const startDateFormatted = today.format('YYYY-MM-DD')
    const endDateFormatted = twoWeeksLater.format('YYYY-MM-DD')
    navigate(`/changes?filter=planned&dateRange=${startDateFormatted},${endDateFormatted}`)
  }

  return (
    <Tile onMouseDown={upcomingChanges?.total_count === 0 ? handleNavigate : undefined}>
      <TileHeader loading={isUpcomingChangesLoading}>
        <TileHeader.Title>{upcomingChanges?.total_count ?? 0}</TileHeader.Title>
        <TileHeader.Subtitle>Upcoming Changes (2 weeks)</TileHeader.Subtitle>
        <TileHeader.Item>
          <IoGitPullRequest className="h-10 w-10 text-th-primary" />
        </TileHeader.Item>
      </TileHeader>
      <TileListContent>
        {upcomingChanges?.changes.map((change) => (
          <TileListItem key={change.id} onMouseDown={() => navigate(`/changes/${change.id}`)}>
            <div>
              <TileListItem.Title>{change.number}</TileListItem.Title>
              <TileListItem.Subtitle>{change.title}</TileListItem.Subtitle>
              <div className="mt-1 text-xs text-th-text-secondary">{formatDateRange(change.starts, change.ends)}</div>
            </div>
          </TileListItem>
        ))}
      </TileListContent>
      {(upcomingChanges?.total_count ?? 0) > 3 && <TileFooter onMouseDown={handleNavigate}>View {(upcomingChanges?.total_count ?? 0) - 3} more...</TileFooter>}
    </Tile>
  )
}

export default UpcomingChangesTile
